"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.DisplayValue = void 0;

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _mobx = require("mobx");

var _class, _descriptor, _descriptor2, _temp;

var DisplayValue = (_class = (_temp =
/*#__PURE__*/
function () {
  function DisplayValue(inputValue, formatter, parser, validators) {
    this.validators = void 0;
    this.formatter = void 0;
    this.parser = void 0;
    (0, _initializerDefineProperty2.default)(this, "inputValue", _descriptor, this);
    (0, _initializerDefineProperty2.default)(this, "editing", _descriptor2, this);
    this.formatter = formatter;
    this.parser = parser;
    this.validators = validators;
    this.inputValue = inputValue;
    this.editing = false;
  }

  (0, _createClass2.default)(DisplayValue, [{
    key: "displayValue",
    get: function get() {
      // console.log('dv: isValid: ' + this.isValid);
      var result;

      if (this.editing || !this.isValid) {
        result = this.inputValue;
      } else if (!this.isValid) {
        result = "Invalid";
      } else {
        result = this.formatter(this.value);
      } // console.log('displayValue: ' + result);


      return result;
    }
  }, {
    key: "isValid",
    get: function get() {
      var result = this.newValue.validationResult.isValid; // valid if there was no validation result or it passed

      result = result === undefined || result; // console.log('isValid: ' + result);

      return result;
    }
  }, {
    key: "newValue",
    get: function get() {
      var parsedValue = this.parser ? this.parser(this.inputValue) : this.inputValue;
      var validationResult = {
        isValid: true
      };

      if (this.validators) {
        validationResult = this.validators(parsedValue);

        if (validationResult.hasNewValue) {
          parsedValue = validationResult.newValue;
        }
      }

      return {
        parsedValue: parsedValue,
        validationResult: validationResult
      };
    }
  }, {
    key: "value",
    get: function get() {
      // console.log('parsedValue inputValue: ' + this.inputValue);
      var result = this.newValue.parsedValue; // console.log('parsedValue result: ' + result);

      return result;
    }
  }, {
    key: "error",
    get: function get() {
      var result = this.newValue.validationResult; // console.log('error: ' + result);

      return result;
    }
  }]);
  return DisplayValue;
}(), _temp), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "inputValue", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "displayValue", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayValue"), _class.prototype), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "editing", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isValid", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "newValue", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "newValue"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "value", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "value"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "error", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "error"), _class.prototype)), _class);
exports.DisplayValue = DisplayValue;